// Consts
import { BinderTypes } from 'Shared/Utils/constants/bindertypes';

export enum AccessOptions {
  allParticipants = 'allParticipants',
  onlySelectedGroupsCanWrite = 'onlySelectedGroupsCanWrite',
  onlySelectedGroupsCanReadOrWrite = 'onlySelectedGroupsCanReadOrWrite'
}

export const binderTemplateLabels = () => ({
  youHaveNotSavedYourChanges: 'You have not saved your changes',
  binderTemplateInfo: 'Template information',
  binderTemplateTabs: 'Template tabs',
  save: 'Save',
  exitEditMode: 'Exit edit mode',
  edit: 'Edit',
  addTabs: 'Add tabs',
  noTabsCreatedForTemplateJustyet: 'No tabs created for template just yet',
  users: 'Users',
  usersAddedToTemplateWillBeAddedToBindersCreatedFromTemplate:
    'Users added to template will be added to binders created from this template',
  binderRoles: 'Binder roles',
  genRoleMetaData: (name, metadataValueForThisRole) => {
    return `${name}.${metadataValueForThisRole}`;
  },
  genUseRoleTypeInThisTemplate: (roleType) => 'Use role type in this template',
  ParticipantsLabels: {
    levelGen: (level) => `${level}`,
    typeToSearch: 'Type to search',
    searchForUsers: 'Search for users'
  },
  LabelsRoleTypeAndRoles: {
    addUser: 'Add user',
    userNameFiltered: 'Users with',
    groupsWith: 'Groups with',
    addGroup: 'Add all participants',
    inviteUsers: 'Invite a new user',
    getAccessLevelLabel: (key, onlyRead) => {
      `${key}${
        key === AccessOptions.onlySelectedGroupsCanReadOrWrite ? onlyRead : ''
      }`;
    },
    genUseRoleTypeInThisTemplate: (roleType) =>
      'Use role type in this template',
    genByRoleType: ({
      tenantSpecific,
      binderRoleType: { name, metadataElementId }
    }) => {
      return name;
    },
    genRoleTypeText: (metadataElementId, metadataValueForThisRole) =>
      `${metadataValueForThisRole}`
  },
  actionMenuLabels: {
    identityFunction: (n) => {
      const labelWithOutEdit = n.split('edit');
      return labelWithOutEdit[1];
    }
  },
  aboutTemplateLabels: {
    aboutTemplate: 'About template',
    binderType: 'Binder type',
    selectBinderType: 'Select binder type',
    templateName: 'Template name',
    templateDescription: 'Template description',
    binderColor: 'Default color',
    binderLogo: 'Binder logo',
    uploadANewLogo: 'Upload a new logo',
    possibleToChange: 'Possible to change',
    notPossibleToChange: 'Not possible to change',
    dropFileHere: 'Drop file here',
    BinderTypesTemplateValueLabel: (templateData) =>
      `${templateData.binderType}`,
    BinderTypesKeyValueLabel: (key) => `${BinderTypes[key]}`,
    selectExistingTemplate: {
      groupName: (key) => `TemplateTypeGroup.${key}`,
      selectTemplateToClone: 'Select template to clone',
      noTemplate: 'No template',
      binderTabStructureToClone: 'Tab structure to clone'
    }
  },
  templateTabEditorLabels: {
    noResultsFor: 'No results for',
    AboutTabTemplate: 'About tab template',
    numberOfSelectedItems: 'Number of selected items',
    search: 'Search',
    selectUserGroups: 'Select user groups',
    tabAccess: 'Tab access',
    addTab: 'Add tab',
    permissionSettingsLabels: {
      genCanReadWrite: (CANREADWRITE) => `${CANREADWRITE}`,
      genCanRead: (CANREAD) => `${CANREAD}`,
      identityKey: (key) => key
    },
    LabelsTabSettings: {
      addShortName: 'Add short name',
      tabAccess: 'Tab access',
      selectUserGroups: 'Select user groups',
      numberOfSelectedItems: 'Number of selected items',
      noResultsFor: 'No results for',
      search: 'Search',
      canChooseVisibility: 'Can choose visibility',
      canNotChooseVisibility: 'Can not choose visibility',
      canChoosePosition: 'Can choose position',
      canNotChoosePosition: 'Can not choose position',
      tabSettings: 'Tab settings',
      tabSettingsHelp: 'Tab settings help',
      subTabSettingsHelp: 'Sub tab settings help',
      tabName: 'Tab name',
      tabShortName: 'Tab short name',
      tabTypesName: 'Tab types name',
      seeSubTabs: 'See sub tabs',
      editTabs: 'Edit tabs',
      advancedSettings: 'Advanced settings',
      advancedSettingsHelp: 'Advanced settings help',
      changeVisibility: 'Change visibility',
      changePosition: 'Change position',
      removeTab: 'Remove tab',
      permissionSettingsLabels: {
        genCanReadWrite: (CANREADWRITE) => `${CANREADWRITE}`,
        genCanRead: (CANREAD) => `${CANREAD}`,
        identityKey: (key) => key
      },
      genTabTypeGroup: (key) => `TabTypeGroup.${key}`,
      identityFunction: (n) => `${n}`
    }
  },
  noResultsFor: 'No results for',
  AboutTabTemplate: 'About tab template',
  numberOfSelectedItems: 'Number of selected items',
  search: 'Search',
  selectUserGroups: 'Select user groups',
  tabAccess: 'Tab access',
  addTab: 'Add tab',
  permissionSettingsLabels: {
    genCanReadWrite: (CANREADWRITE) => `${CANREADWRITE}`,
    genCanRead: (CANREAD) => `${CANREAD}`,
    identityKey: (key) => `${key}`
  },
  LabelsTabSettings: {
    addShortName: 'Add short name',
    tabAccess: 'Tab access',
    selectUserGroups: 'Select user groups',
    numberOfSelectedItems: 'Number of selected items',
    noResultsFor: 'No results for',
    search: 'Search',
    canChooseVisibility: 'Can choose visibility',
    canNotChooseVisibility: 'Can not choose visibility',
    canChoosePosition: 'Can choose position',
    canNotChoosePosition: 'Can not choose position',
    tabSettings: 'Tab settings',
    tabSettingsHelp: 'Tab settings help',
    subTabSettingsHelp: 'Sub tab settings help',
    tabName: 'Tab name',
    tabShortName: 'Tab short name',
    tabTypesName: 'Tab types name',
    seeSubTabs: 'See sub tabs',
    editTabs: 'Edit tabs',
    advancedSettings: 'Advanced settings',
    advancedSettingsHelp: 'Advanced settings help',
    changeVisibility: 'Change visibility',
    changePosition: 'Change position',
    removeTab: 'Remove tab',
    permissionSettingsLabels: {
      genCanReadWrite: (CANREADWRITE) => `${CANREADWRITE}`,
      genCanRead: (CANREAD) => `${CANREAD}`,
      identityKey: (key) => key
    },
    genTabTypeGroup: (key) => `TabTypeGroup.${key}`,
    identityFunction: (n) => `${n}`
  }
});
